import Button from "components/base/Button";
import { FileSelector, Select } from "components/base/Form";
import StatusSelector from "components/base/StatusSelector";
import useFileUploader from "hooks/useFileUploader";
import { useContext } from "react";
import { GTMProjectContext } from "../GTMProjectContext";
import useSaveGTMProject from "../useSaveGTMProject";
import { InlineSpinner } from "components/base/Spinner";

const TrialOrderView = () => {
  const { originalGTMProject, saveProject, saveProjectRes } =
    useContext(GTMProjectContext);

  const { state, onChange, loading } = useSaveGTMProject(
    originalGTMProject.id,
    "trialOrderData",
    JSON.parse(originalGTMProject.trialOrderData),
    500,
  );

  const qcStandardUploader = useFileUploader((urls) => {
    onChange("qcStandards", [...(state.qcStandards || []), ...urls]);
  }, "AWS");

  const packingInstructionUploader = useFileUploader((urls) => {
    onChange("packingInstructions", [
      ...(state.packingInstructions || []),
      ...urls,
    ]);
  }, "AWS");

  function completeHandler() {
    if (window.confirm("Are you sure you want to complete the trial order?")) {
      saveProject({
        variables: {
          id: originalGTMProject.id,
          trialOrderConfirmedAt: new Date().toISOString(),
        },
      });
    }
  }

  function handleDeleteQCStandard(index) {
    if (window.confirm("Are you sure you want to delete this QC standard?")) {
      onChange(
        "qcStandards",
        state.qcStandards.filter((_, i) => i !== index),
        false,
      );
    }
  }

  function handleDeletePackingInstruction(index) {
    if (
      window.confirm(
        "Are you sure you want to delete this packing instruction?",
      )
    ) {
      onChange({
        data: {
          packingInstructions: state.packingInstructions.filter(
            (_, i) => i !== index,
          ),
        },
      });
    }
  }

  const disabled = originalGTMProject.trialOrderConfirmedAt;

  console.log("originalGTMProject", originalGTMProject);

  return (
    <div className="card">
      <div className="flex justify-between">
        <h5>
          Trial Order Follow up (<b className="text-orange-500">Stella</b>)
        </h5>
        {loading && <InlineSpinner size={18} />}
      </div>

      {originalGTMProject.trialOrderConfirmedAt && (
        <div className="text-green-600 font-extrabold mt-1">
          🟢 Confirmed at{" "}
          {new Date(originalGTMProject.trialOrderConfirmedAt).toLocaleString()}.
        </div>
      )}

      <div className="mt-4 space-y-4 whitespace-nowrap">
        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="text-orange-500">Stella</td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Product Created in System:</td>
                <td className="text-right text-xs">
                  <input
                    type="checkbox"
                    disabled={disabled}
                    checked={state.productCreatedInSystem}
                    onChange={(e) =>
                      onChange("productCreatedInSystem", e.target.checked)
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="text-orange-500">Sharon</td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Trial Order Placed:</td>
                <td className="text-right text-xs">
                  <input
                    type="checkbox"
                    disabled={disabled}
                    checked={state.trialOrderPlaced}
                    onChange={(e) =>
                      onChange("trialOrderPlaced", e.target.checked)
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="text-orange-500">Jade / Alex</td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Production:</td>
                <td className="text-right text-xs">
                  <Select
                    disabled={disabled}
                    value={state.productionStatus}
                    onChange={(e) =>
                      onChange("productionStatus", e.target.value, false)
                    }
                  >
                    <option>🔴 Awaiting</option>
                    <option>🟡 Processing</option>
                    <option>🟢 Done</option>
                  </Select>
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Packing:</td>
                <td className="text-right text-xs">
                  <Select
                    disabled={disabled}
                    value={state.packingStatus}
                    onChange={(e) =>
                      onChange("packingStatus", e.target.value, false)
                    }
                  >
                    <option>🔴 Awaiting</option>
                    <option>🟡 Processing</option>
                    <option>🟢 Done</option>
                  </Select>
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Assembling:</td>
                <td className="text-right text-xs">
                  <StatusSelector
                    disabled={disabled}
                    value={state.assemblingStatus}
                    onChange={(e) =>
                      onChange("assemblingStatus", e.target.value, false)
                    }
                  />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>QC Standard:</td>
                <td className="w-full text-xs py-0 divide-y divide-gray-100 dark:divide-gray-700">
                  {state.qcStandards?.length > 0 &&
                    state.qcStandards.map((url, index) => (
                      <div
                        key={index}
                        className="py-2 flex items-center justify-between"
                      >
                        <a href={url} target="_blank" rel="noopener noreferrer">
                          {url.split("/").pop().split("-").slice(1).join("-")}
                        </a>

                        {!disabled && (
                          <Button
                            trash
                            onClick={() => handleDeleteQCStandard(index)}
                          />
                        )}
                      </div>
                    ))}

                  {!disabled && (
                    <div className="py-2">
                      <FileSelector
                        title="+ Upload File"
                        uploading={qcStandardUploader.isUploading}
                        onChange={(e) => {
                          const files = [...e.target.files];
                          qcStandardUploader.handleFileUpload(files);
                          e.target.value = null;
                        }}
                      />
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="text-orange-500">Chrissie / Cherry</td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Beautyshots:</td>
                <td className="text-right text-xs">
                  <input
                    type="checkbox"
                    disabled={disabled}
                    checked={state.beautyshots}
                    onChange={(e) => onChange("beautyshots", e.target.checked)}
                  />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>Packing Instructions:</td>
                <td className="w-full text-xs py-0 divide-y divide-gray-100 dark:divide-gray-700">
                  {state.packingInstructions?.length > 0 &&
                    state.packingInstructions.map((url, index) => (
                      <div
                        key={index}
                        className={`py-2 flex items-center justify-between`}
                      >
                        <a href={url} target="_blank" rel="noopener noreferrer">
                          {url.split("/").pop().split("-").slice(1).join("-")}
                        </a>

                        {!disabled && (
                          <Button
                            trash
                            onClick={() =>
                              handleDeletePackingInstruction(index)
                            }
                          />
                        )}
                      </div>
                    ))}

                  {!disabled && (
                    <div className="py-2">
                      <FileSelector
                        title="+ Upload Images"
                        uploading={packingInstructionUploader.isUploading}
                        onChange={(e) => {
                          const files = [...e.target.files];
                          packingInstructionUploader.handleFileUpload(files);
                          e.target.value = null;
                        }}
                      />
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {!originalGTMProject.trialOrderConfirmedAt && (
        <div className="mt-6">
          <div className="flex justify-end">
            <Button onClick={completeHandler} loading={saveProjectRes.loading}>
              Complete Trial Order
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrialOrderView;
